<template>
    <div>
        <Row>
            <Col span="5" class="conLeftTwo">
            <div class="top">
                <ButtonGroup size="small">
                    <Button style="height: 30px;line-height: 30px;padding: 0 56px;">公司部门</Button>
                    <Button style="height: 30px;line-height: 30px;padding: 0 10px;color:#333;font-size: 24px;" v-hasPermission="'web_member_department'" @click="handleRender">+</Button>
                </ButtonGroup>
            </div>
            <Scroll class="department-list" height = '474'>
                <div class="main">
                    <Tree :data="departmentList" :render="renderContent"></Tree>
                </div>
            </Scroll>
            </Col>
            <Col span="19">
                <div class="top-Lv1">
                    <span class="tittle-lv1">{{com_name}}（<span>{{members}}</span>人）</span>
                    <div v-if="addDep" class="fr" @click="handleRender" style="margin-top:6px;margin-right:10px;color: #3399ff;cursor: pointer">
                    添加子部门
                    </div>
                </div>
                <div class="mainContent">
                    <Table
                        size='small'
                        :columns="columns"
                        :data="data2"
                        @on-selection-change="selectItem"
                    ></Table>
                    <div class="mainNav">
                        <Button type="ghost" v-hasPermission="'web_member_add'" size="small" @click="toAdd">添加成员</Button>
                        <Button type="ghost" v-hasPermission="'web_member_del'" size="small" @click="del">删除</Button>
                        <Button type="ghost" v-hasPermission="'web_member_roles'" v-if="boolean" size="small" style="float: right" @click="modal6 = true">变更权限组</Button>
                        <Button type="ghost" v-hasPermission="'web_member_roles'" v-if="!boolean" size="small" style="float: right;color: #c3cbd6;">变更权限组</Button>
                    </div>
                </div>
                <Row style="padding:10px;">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        show-total
                        show-elevator
                        v-on:on-change="pageChange"
                    ></Page>
                </Row>
            </Col>
        </Row>

        <!--删除用户-->
        <Modal
            v-model="delModal"
            @on-ok="confirmDel"
            title="删除用户"
            width="300">
            <p>用户信息删除后不可恢复，确认删除？</p>
        </Modal>

        <!--新建部门-->
        <Modal
            v-model="loading"
            title="新建部门"
            @on-ok="formSubmit">
            <Form :model="formItem" :label-width="80">
            <FormItem label="上级部门">
                <Select v-model="model2">
                    <Option v-for="(item,index1) in formItem.select" :value="item.value" :key="index1">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem label="新建部门">
                <Input v-model="formItem.input"  placeholder="新建部门名称"></Input>
            </FormItem>
            <FormItem label="部门属性">
                <Select v-model="model4">
                    <Option v-for="(item,index2) in formItem.attribute" :value="item.id" :key="index2">{{ item.attribute }}</Option>
                    <Option :value="-1">自定义</Option>
                </Select>
            </FormItem>
            <FormItem>
                <Input v-model="formItem.custom" v-if="custom"  placeholder="自定义部门属性"></Input>
            </FormItem>
            </Form>
        </Modal>

        <!--变更权限组-->
        <Modal
            v-model="modal6"
            title="变更权限组"
            :loading="loading1"
            @on-ok="asyncOK">
            <Form :model="formItem" :label-width="100">
                <FormItem label="权限组变更为：">
                    <Select v-model="rolesValue">
                        <Option v-for="(item,key) in formItem.roles" :value="item.id" :key="key">{{item.alias}}</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>

        <!--修改部门名称-->
        <Modal
            v-model="modal8"
            title="修改部门名称"
            @on-ok="depUpdate">
            <Form :model="formItem" :label-width="80">
                <FormItem label="部门名称">
                    <Input v-model="formItem.depName" placeholder="请输入新的部门名称"></Input>
                </FormItem>
            </Form>
        </Modal>

        <!--用户修改密码-->
        <Modal
            v-model="modal10"
            title="用户修改密码"
            @on-ok="updatePass">
            <Form :model="formItem" :rules="ruleValidate" :label-width="80">
                <Alert type="warning">
                    <template slot="desc">
                        注意：请慎重使用此功能，修改用户密码请联系用户，以避免密码修改后用户登录不上等情况！
                    </template>
                </Alert>
                <FormItem label="用户名称：">
                    <FormItem>
                        <Input v-model="formItem.name" :disabled="true" value=""></Input>
                    </FormItem>
                </FormItem>
                <FormItem label="用户新密码">
                    <FormItem prop="password">
                        <Input v-model="formItem.password" name="password" type="password" placeholder="请输入6-12位密码，可包含字母、数字或下划线"></Input>
                    </FormItem>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    import ruleValidate from '../../validator';
    export default {
        name: 'memberInfo',
        data() {
            return {
                value3: '',
                data5: [],
                buttonProps: {
                    type: 'ghost',
                    size: 'small',
                },
                button4:'权限组',
                theme2: 'light',
                model4: 0,
                loading: false,
                value1: '',
                modal6: false,
                modal8: false,
                modal9: false,
                modal10: false,
                loading1: true,
                formItem:{
                    input: '',
                    select: {},
                    roles:[],
                    attribute:[],
                    custom:'',
                    depName:'',
                    password:'',
                    name:'',
                    userId: ''
                },
                departmentList:[],
                bol:false,
                columns:[
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '姓名',
                        key: 'fullname',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: '#4fa8f9',
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.toMenberDetail(params.row)
                                        }
                                    }
                                }, params.row.fullname)
                            ])
                        }
                    },
                    {
                        title: '部门',
                        key: 'department',
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: '职务',
                        key: 'duty',
                        width: 110,
                        align: 'center',
                    },
                    {
                        title: '是否主管',
                        key: 'director',
                        align: 'center',
                    },
                    {
                        title: '手机',
                        key: 'mobile',
                        width: 110,
                        align: 'center',
                    },
                    {
                        title: '权限组',
                        key: 'roles',
                        align: 'center',
                    },
                    {
                        title: '操作',
                        key: 'n6',
                        width: 170,
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.status === '1') {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_member_stop',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.discontinuation(params.row.id)
                                            }
                                        }
                                    }, '启用'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            marginRight: '5px',
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_member_del',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.del(params.row.id)
                                            }
                                        },

                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_member_update',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.$router.push({path: 'memberChange', query: {id:params.row.id,page:this.page}})
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_permission',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.$router.push({name: 'permission',params:{id:params.row.id,button:'个人权限',page:params.row.paths}})
                                                this.$store.dispatch('setPage', '3');
                                            }
                                        }
                                    }, '权限'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_update_password',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.userInfoShow(params.row.id,params.row.fullname);
                                            }
                                        }
                                    }, '修改密码'),
                                ]);
                            } else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_member_stop',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.discontinuation(params.row.id)
                                            }
                                        }
                                    }, '停用'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            marginRight: '5px',
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_member_del',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.del(params.row.id)
                                            }
                                        },

                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_member_update',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.$router.push({path: 'memberChange', query: {id:params.row.id,page:this.page}})
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_permission',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.$router.push({name: 'permission',params:{id:params.row.id,button:'个人权限',page:params.row.paths}})
                                                this.$store.dispatch('setPage', '3');
                                            }
                                        }
                                    }, '权限'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style: {
                                            color: ' #2d8cf0',
                                        },
                                        directives: [
                                            {
                                                name:'hasPermission',
                                                value:'web_update_password',
                                            }
                                        ],
                                        on: {
                                            click: () => {
                                                this.userInfoShow(params.row.id,params.row.fullname);
                                            }
                                        }
                                    }, '修改密码'),
                                ]);
                            }

                        }
                    }
                ],
                data2: [],
                page: 1,
                limit: 9,
                total: 1,
                model2: 0,
                delModal: false,
                delId: '',
                value: '',
                result: [],
                depTitle: '',
                depId: 0,
                rolesValue:1,
                oldRoles:'',
                boolean:false,
                custom:false,
                depData:{},
                depNameUpdate: false,
                webUserList:[],
                addDep: true,
            }
        },
        computed: {
            ruleValidate: function () {
                return ruleValidate
            },
            com_name: function () {
                return this.$store.getters.comInfo.com_name
            },
            members: function () {
                return this.$store.getters.comInfo.members
            }
        },
        beforeMount(){
            this.page = this.$route.query.page ? this.$route.query.page : 1;
            this.depNameUpdate = false;
            this.getDepartmen();
            this.getMemberList();
        },
        mounted() {
            this.isOperation();
            // this.creaters();
        },
        methods: {
            // 打开删除成员弹窗
            del(id) {
                this.depNameUpdate = false;
                this.delModal = true;
                this.delId = id;
            },
            // 确认删除成员
            confirmDel() {
                this.$http.post(this.$api.DEL_USER + this.delId,{
                    uid: this.$store.getters.userInfo.id
                }).then(res => {
                    if(res.data.status === '1'){
                        this.delId = '';
                        this.getMemberList();
                        this.$Message.info('删除成功') ;
                    }else{
                        this.$Message.error(res.data.msg) ;
                    }
                }, err => {
                    this.delId = '';
                    this.getMemberList();
                    this.$Message.error ('网络错误');
                });
            },

            //停用用户
            discontinuation(id){
                this.$http.post(this.$api.DEL_USER + id,{uid:this.$store.getters.userInfo.id,stopUse:1}).then(res => {
                    if(res.data.status === '1'){
                        this.getMemberList();
                        this.$Message.info(res.data.msg) ;
                    }else{
                        this.$Message.error(res.data.msg) ;
                    }
                }, err => {
                    this.delId = '';
                    this.getMemberList();
                    this.$Message.error ('网络错误');
                });
            },

            //修改用户密码
            updatePass(){
                this.$http.post(this.$api.WEB_SET_PWD , {
                    uid:this.formItem.userId,
                    password : this.formItem.password,
                }).then(res=>{
                    if(res.data.status === '1'){
                        this.$Message.info(res.data.msg);
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                },err=>{
                    this.$Message.error('网络错误');
                })

            },

            //用户详情（修改密码显示用户信息）
            userInfoShow(id,name){
                this.modal10 = true;
                this.formItem.name = name;
                this.formItem.userId = id;
                this.formItem.password = '';
                this.$store.dispatch('setPage', '4')
            },

            //渲染按钮删除，修改（左边部门列表）
            renderContent (h, { root, node, data }) {
                let permissionList = sessionStorage.getItem('permission');
                if(this.depNameUpdate === true && this.depId === data.value && permissionList.includes('web_member_department_edit')){
                    return h('span', {
                        style: {
                            display: 'inline-block',
                            width: '100%',
                            cursor:'pointer'
                        },
                        on: {
                            click: () => { this.getSelectedNodes(data) }
                        }
                    }, [
                        h('span', [
                            h('Icon', {
                                props: {
                                    type: 'ios-paper-outline'
                                },
                                style: {
                                    marginRight: '8px'
                                }
                            }),
                            h('span', data.title)
                        ]),
                        h('span', {
                            style: {
                                display: 'inline-block',
                                float: 'right',
                                marginRight: '36px'
                            }
                        },[
                            h('Button', {
                                props: Object.assign({}, this.buttonProps, {
                                    icon: 'android-more-vertical'
                                }),
                                style: {
                                    border: '0px',
                                },
                                on: {
                                    click: () => { this.appModel(data) }

                                }
                            }),
                        ]),
                        h('div', {
                            style: {
                                float: 'right',
                                position: 'relative',
                                marginRight: '70px',
                                right:'-74px',
                            }
                        }, [
                            h('Button', {
                                props: Object.assign({}, this.buttonProps, {
                                    icon: 'edit',
                                }),
                                on: {
                                    click: () => { this.append(data) }
                                }
                            }),
                        ]),
                        h('div', {
                            style: {
//                            display: 'inline-block',
                                float: 'right',
                                position: 'relative',
                                marginRight: '-9px',
                                right:'-122px',
                            }
                        }, [
                            h('Button', {
                                props: Object.assign({}, this.buttonProps, {
                                    icon: 'trash-a',
                                }),
                                on: {
                                    click: () => { this.remove (root, node, data) }
                                }
                            }),
                        ])
                    ]);
                }else{
                    return h('span', {
                        style: {
                            display: 'inline-block',
                            width: '100%',
                            cursor:'pointer'
                        },
                        on: {
                            click: () => {
                                this.getSelectedNodes(data);
                            }
                        }
                    }, [
                        h('span', [
                            h('Icon', {
                                props: {
                                    type: 'ios-paper-outline'
                                },
                                style: {
                                    marginRight: '8px'
                                }
                            }),
                            h('span', data.title)
                        ]),
                        h('span', {
                            style: {
                                display: 'inline-block',
                                float: 'right',
                                marginRight: '36px'
                            }
                        },[
                            h('Button', {
                                props: Object.assign({}, this.buttonProps, {
                                    icon: 'android-more-vertical'
                                }),
                                style: {
                                    border: '0px',
                                },
                                on: {
                                    click: () => { this.appModel(data) }
                                }
                            }),
                        ])
                ])
                }

            },

            //是否显示部门删除编辑按钮（左边部门列表）
            appModel(){
                this.depNameUpdate = true;
            },

            // 修改部门弹窗（左边部门列表）
            append (data) {
                this.depNameUpdate = false;
                this.modal8 = true;
                this.depData = data;
                this.formItem.depName = data.title;
            },

            //删除部门（左边部门列表）
            remove (root, node, data) {
                this.depNameUpdate = false;
                this.$http.post(this.$api.DEPARTMENT_DELETE , {
                    id:data.value,
                    uid:this.$store.getters.userInfo.id
                }).then(res=>{
                    if(res.data.status == 1){
                        this.$Message.info(res.data.msg);
                        this.getDepartmen();
                        this.getMemberList();
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                },err=>{
                    this.$Message.error('网络错误');
                })
            },

            //修改部门名称（左边部门列表）
            depUpdate(){
                if(!this.formItem.depName){
                    this.$Message.error('部门名称部门为空');
                    return false;
                }
            this.$http.post(this.$api.DEPARTMENT_UPDATE,{
                id:this.depData.value,
                uid:this.$store.getters.userInfo.id,
                depName:this.formItem.depName
            }).then(res=>{
                if(res.data.status == 1){
                    this.getDepartmen();
                    this.getMemberList();
                    this.$Message.info(res.data.msg);
                }else{
                    this.$Message.error(res.data.msg);
                }
            },err=>{
                this.$Message.error('网络错误');
            })
            },

            //变更组权限
            asyncOK () {
                this.$http.post(this.$api.CHECK_ROLES, {
                        id:this.rolesValue,
                        uid:this.delId,
                        oldRoles:this.oldRoles,
                        com_id:this.$store.getters.userInfo.com_id
                    }).then(res=>{
                        if(res.data.status == 1){
                            this.modal6 = false;
                            this.getDepartmen();
                            this.getMemberList();
                            this.$Message.info(res.data.msg);
                        }
                },err=>{
                    this.$Message.error('网络错误') ;
                    this.modal6 = false;
                })

            },

            //获取权限组列表（变更权限组）
            getRoles(){
                this.$http.get(this.$api.ROLES +'?com_id='+ this.$store.getters.userInfo.com_id,
                    {}).then(res=>{
                    if(res.data.status == 1){
                        this.rolesValue = res.data.data[0].id;
                        this.formItem.roles = res.data.data;
                        this.roles();
                    }else{
                        this.formItem.roles = [];
                    }
                })
            },

            //处理角色信息
            roles(){
                if(this.data2.length > 0){
                    for(var j=0; j< this.data2.length; j++){
//                        this.data2[j].director = (this.data2[j].director == 1 ? '是' : '否')
                        for(var k=0; k< this.formItem.roles.length; k++)
                        {
                            if(this.data2[j].roles == this.formItem.roles[k].id){
                                this.data2[j].roles = this.formItem.roles[k].alias;
                                this.data2[j].oldRoles = this.formItem.roles[k].id;
                            }
                        }
                    }
                }
            },

            //初始化创建人列表模（转让创建人）
            // creaters(){
            //     this.$http.post(this.$api.WEB_USER_LIST,{com_id:sessionStorage.getItem('com_id')}).then(res => {
            //         if(res.data.status == 1 ){
            //             this.webUserList = res.data.data;
            //             console.log(this.webUserList)
            //         }else{
            //             this.webUserList = [];
            //         }
            //     },err=>{
            //         this.$Message.error ('网络错误');
            //     })
            // },

            //转让创建人搜索功能
            filterMethod (value, option) {
                return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
            },

            //转让管理员
            transfer(){
                var position = this.value3.indexOf('>');
                var department = this.value3.substring(position+1);
                position = this.value3.indexOf('=');
                var user = this.value3.substring(0,position);
                this.$http.post(this.$api.TRANSFER ,{
                    department: department,
                    fromuid:this.$store.getters.userInfo.id,
                    user:user,
                    com_id: this.$store.getters.userInfo.com_id,
            }).then(res => {
                    if(res.data.status == 1){
                        this.$Message.info(res.data.msg);
                        this.$router.push('login');
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                }, err => {
                    this.$api.errcallback(err)
                });
            },

            //选择部门
            getSelectedNodes(val){
                this.depTitle = val.title;
                this.page = 1;
                this.departmentId();
                this.getMemberList();
            },

            //添加子部门  弹框
            handleRender(){
                this.depNameUpdate = false;
                this.loading = true;
            },

            //添加子部门
            formSubmit(){
                this.$http.post(this.$api.DEPARTMENT,{
                    'pid' : this.model2,
                    'depName' : this.formItem.input,
                    'com_id': this.$store.getters.userInfo.com_id,
                    'custom': this.formItem.custom,
                    'attr':this.model4,
                    'uid':this.$store.getters.userInfo.id
                }).then(res => {
                    if(res.data.status == 1){
                        this.$Message.info(res.data.msg);
                        this.formItem.input = '';
                        this.model2 = 0;
                        this.$Modal.remove();
                        this.getDepartmen();
                    }else{
                        this.$Message.error (res.data.msg);
                    }
                }, err => {
                    this.$Message.error ('网络错误');
                });

            },

            //用户列表
            getMemberList() {
                var that = this;
                if(this.depId === 0){
                    var data =  {
                        com_id: sessionStorage.getItem('com_id'),
                        limit: this.limit,
                        page: this.page,
                    }
                }else{
                    var data =  {
                        com_id: sessionStorage.getItem('com_id'),
                        limit: this.limit,
                        department: this.depId,
                        page: this.page,
                    }
                }
                this.$http.post(this.$api.USER_INDEX,data).then(res => {
                    if(res.data.status ==1){
                        let datas = res.data.data;
                        that.data2 = datas.data;
                        that.getRoles();
                        that.page = datas.current_page;
                        that.total = datas.total;
                    }else{
                        that.data2 = [];
                        that.page = 1;
                        that.limit = 9;
                        that.total = 0;
                    }
                }, err => {
                    this.$api.errcallback(err)
                });
            },

            //会员列表
            pageChange(page) {
                this.page = page;
                this.$http.post(this.$api.USER_INDEX, {
                    com_id: this.$store.getters.userInfo.com_id,
                    department: this.depId,
                    limit: this.limit,
                    page: this.page
                }).then(res => {
                    let data = res.data.data;
                    this.data2 = data.data;
                    this.getRoles();
                    this.department();
                    this.page = data.current_page;
                    this.total = data.total;
                }, err => {
                    this.data2 = [];
                    this.page = 1;
                    this.limit = 9;
                    this.total = 0;
                });
            },

            //获取部门id
            departmentId(){
                if(this.formItem.select.length > 0){
                    this.formItem.select.map(item=>{
                        if(item.label == this.depTitle){
                            this.depId = item.value;
                            this.getMemberList();
                        }
                    })
                }
            },

            //处理部门数据信息
            department(){
                if(this.data2.length > 0){
                    for(var j=0; j< this.data2.length; j++){
                        for(var i=0; i< this.formItem.select.length; i++)
                        {
                            if(this.data2[j].department == this.formItem.select[i].value){
                                this.data2[j].department = this.formItem.select[i].label;
                            }
                        }
                    }
                }
            },

            //获取部门信息
            getDepartmen(){
                this.$http.post(this.$api.DEPARTMENT_LIST,{
                    com_id:sessionStorage.getItem('com_id')
                }).then(res => {
                    if(res.data.status == 1){
                        this.departmentList = [];
                        let data = res.data.result;
                        this.formItem.select = data;
                        this.formItem.attribute = res.data.attribute;
                        this.model3 = this.formItem.attribute[0].id;
                        res.data.data.map(res=>{
                            let obj = {};
                            if(res.children.length > 0) {
                                obj.title = res.label;
                                obj.expand = true;
                                obj.value = res.value;
                                obj.children = this.departmentData(res.children);
                            }else{
                                obj.value = res.value;
                                obj.title = res.label;
                            }
                            if(res.pid == 0){
                                this.model2 = res.value;
                                obj.title = res.label;
                                obj.value = res.value;
                                obj.expand = true;
                                obj.render = (h, { root, node, data }) => {
                                    return h('span', {
                                        style: {
                                            display: 'inline-block',
                                            width: '100%',
                                            cursor:'pointer'
                                        },
                                        on: {
                                            click: () => { this.getSelectedNodes(data) }
                                        }
                                    }, [
                                        h('span', [
                                            h('Icon', {
                                                props: {
                                                    type: 'ios-folder-outline'
                                                },
                                                style: {
                                                    marginRight: '8px'
                                                }
                                            }),
                                            h('span', data.title)
                                        ]),
                                    ]);
                                };
                                obj.children = this.departmentData(res.children);
                            }
                            this.departmentList.push(obj);
                            this.model2 = this.formItem.select[0].value;
                        });
                    }else{
                        this.$Message.error('网络错误');
                    }
                }, err => {
                    this.$api.errcallback(err)
                });
            },

            //处理部门数据
            departmentData(data){
                let vm = this
                let arr = [];
                data.map(item=>{
                    let obj = {};
                    if(item.children.length > 0){
                        obj.title= item.label;
                        obj.expand= true;
                        obj.value = item.value;
                        obj.children = vm.departmentData(item.children);
                    }else{
                        obj.value = item.value;
                        obj.title= item.label;
                    }
                    arr.push(obj);
                })
                return arr;
            },

            //添加用户
            toAdd() {
                this.$router.push('memberAdd')
            },

            //判断用户是否有操作权限
            isOperation(){
                let permissionList = sessionStorage.getItem('permission');
                if(!permissionList.includes('web_update_password') && !permissionList.includes('web_permission') && !permissionList.includes('web_member_update') && !permissionList.includes('web_member_del')){
                this.columns = [
                        {
                            type: 'selection',
                            width: 60,
                            align: 'center'
                        },
                        {
                            title: '姓名',
                            key: 'fullname',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style: {
                                            color: '#4fa8f9',
                                            cursor: 'pointer'
                                        },
                                        on: {
                                            click: () => {
                                                this.toMenberDetail(params.row)
                                            }
                                        }
                                    }, params.row.fullname)
                                ])
                            }
                        },
                        {
                            title: '部门',
                            key: 'department',
                            width: 100,
                            align: 'center',
                        },
                        {
                            title: '职务',
                            key: 'duty',
                            width: 110,
                            align: 'center',
                        },
                        {
                            title: '是否主管',
                            key: 'director',
                            align: 'center',
                        },
                        {
                            title: '手机',
                            key: 'mobile',
                            width: 110,
                            align: 'center',
                        },
                        {
                            title: '权限组',
                            key: 'roles',
                            align: 'center',
                        },
                    ];
                }
                if(!permissionList.includes('web_member_department')){
                    this.addDep = false;
                }
            },

            //成员详情
            toMenberDetail(curinfo) {
                let permissionList = sessionStorage.getItem('permission');
                if(!permissionList.includes('web_member_show')){
                    this.$Message.error('抱歉，您没有查看权限');
                    return false;
                }
                this.$router.push({path: 'memberDetails', query: {curinfo: curinfo}})
            },

            //表格左侧多选按钮
            selectItem(val) {
                this.depNameUpdate = false;
                let ids = '';
                var roles = '';
                val.map(i => {
                    ids += i.id + ',';
                    roles += (i.oldRoles ?  i.oldRoles : -1) + ','
                });
                if(roles.length > 0){
                    this.boolean = true;
                }else{
                    this.boolean = false;
                }
                this.delId = ids;
                this.oldRoles = roles;
            }
        },
        watch: {
            'model4':function(val){
                if(val === -1){
                    this.custom = true;
                }else{
                    this.custom = false;
                }
            },
            'modal9':function (val) {
                if(val == true){
                    this.depNameUpdate = false;
                }
            }
        },
    }
</script>

<style scoped>
    .main {
        padding: 12px 0 12px 2px;
    }

    .main li {
        padding: 5px 10px;
        font-size: 13px;
        height: 28px;
        cursor: pointer;
    }
    .main li.selected{
        background: #2d8cf0;
        color: #fff;
    }
    .main li i {
        margin-left: 2px;
        margin-right: 8px;
        font-size: 14px;
        line-height: 21px;
        vertical-align: middle;
    }

    .conRight {
        padding: 10px 26px;
    }

    .mainNav {
        height: 36px;
        border-bottom: 1px solid #ccc;
    }

    .mainContent h3 {
        height: 26px;
        font-weight: 400;
    }

    .mainNav button {
        background-color: #fff;
    }

    .ivu-table-small td button {
        border: 1px;
    }




    .demo-auto-complete-item{
        padding: 4px 0;
        border-bottom: 1px solid #F6F6F6;
    }
    .demo-auto-complete-group{
        font-size: 12px;
        padding: 4px 6px;
    }
    .demo-auto-complete-group span{
        color: #666;
        font-weight: bold;
    }
    .demo-auto-complete-group a{
        float: right;
    }
    .demo-auto-complete-count{
        float: right;
        color: #999;
    }
    .demo-auto-complete-more{
        display: block;
        margin: 0 auto;
        padding: 4px;
        text-align: center;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/member/memberInfo.vue